export const generateExportTimestamp = () =>
  `${new Date().toISOString().replace(/:/g, '-').split('.')[0]}Z`;

export const buildExportFilename = (prefix: string) => `${prefix}_${generateExportTimestamp()}`;
